import {UiItemState,SetItemAction} from '../types/types'
import {uiItemNames, actionTypes, pdfMode, currPathValue, saveButtonMode, LANG} from '../types/enums'

const initialUiItemState:UiItemState = {
    [uiItemNames.currentUser] : {fullName: '', userRno: -1, userId: '', eMail: '', isActive: true},
    [uiItemNames.currentUserGroups] : [],
    [uiItemNames.hasRequiredGroups]: false,
    [uiItemNames.currentPath]: currPathValue.HomePage,
    [uiItemNames.previousPath]: [],
    [uiItemNames.recentDocuments]: [],
    [uiItemNames.favoriteDocuments]: [],
    [uiItemNames.myActivities]: [],
    [uiItemNames.headerText]: "",
    [uiItemNames.selectedDocument]: null,
    [uiItemNames.selectedActivity]: null,
    [uiItemNames.OpenFileInfo]: null,
    [uiItemNames.pdfViewerClientSide]: false,
    [uiItemNames.pdfViewerMode]: pdfMode.view,
    [uiItemNames.documentSearchList]: [],
    [uiItemNames.revisionPermisions]: [],
    [uiItemNames.errorMsgVisible]: false,
    [uiItemNames.errorMessage]: {},
    [uiItemNames.pdfViewerSaveButtonMode]: saveButtonMode.save,
    [uiItemNames.language] : LANG.NO,
    [uiItemNames.actItemBL] : null,
    [uiItemNames.actRecsBL] : null

  };


export const uiItems = (state: UiItemState = initialUiItemState, action:SetItemAction):UiItemState => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.SET_ITEMS:
            switch (payload.items) {
                case uiItemNames.selectedRevPermisions:
                    // console.log("payload",payload)
                    return {
                        ...state, // copy the state (level 0)
                        selectedDocument: {
                            ...state.selectedDocument!,
                            [payload.value.Attribute]: payload.value.Value
                        }    
                    }
                case uiItemNames.wfDocuments:
                        // console.log("payload",payload)
                        return {
                            ...state, // copy the state (level 0)
                            selectedActivity: {
                                ...state.selectedActivity!,
                                [payload.value.Attribute]: payload.value.Value
                            }    
                        }
                default:
                    // console.log("Default action fired")
                    return {
                        ...state, // copy the state (level 0)
                        [payload.items]: payload.value
                        }
            }
        case actionTypes.CLEAR_ITEMS:
            return Object.assign({}, state, {
                //set to initial state
                [payload.items]: initialUiItemState[payload.items],
            });
        default:
            return state;
    }
}